module.exports = __webpack_public_path__ + "static/media/screenshot(24).ee34d787.jpg";